<template>
  <div class="clipboard-alert">
    <p>Copiado para área de transferência</p>
  </div>
</template>

<script>
export default {
  name: 'clipboard-alert',
  props: {
    time: {
      type: Number,
      default: 5000
    }
  },
  data () {
    return {
      timeout: null
    }
  },
  methods: {
    hideAlert () {
      this.$emit('hide')
    },
    clearTimeout () {
      clearTimeout(this.timeout)
    },
    setTimeout () {
      this.timeout = setTimeout(() => {
        this.hideAlert()
      }, this.time)
    }
  },
  mounted () {
    this.setTimeout()
  }
}
</script>

<style scoped lang="less">
.clipboard-alert {
  position: fixed;
  top: 85%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    width: 338px;
    height: 39px;
    background-color: #000000;
    color: #FFFFFF;
    border-radius: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
